export type VerifyAccountFailure = 'missingConfiguration' | 'networkError' | 'httpError' | 'invalidResponse'

export class VerifyAccountRequestError extends Error {
  constructor(
    readonly failure: VerifyAccountFailure,
    readonly httpStatus?: number,
  ) {
    super(`Account verification failed: ${failure}`)
    this.name = 'VerifyAccountRequestError'
  }
}
